import useAuth from '@/hooks/useAuth';

// V2 Order Flow is now open to every authenticated admin (customer + tenant).
//
// During the pilot it was scoped to two customer accounts via the
// commented-out allowlist below. To re-engage the pilot, uncomment the
// Set declaration AND the customer-admin branch in the hook body.
// const ORDER_FLOW_V2_ALLOWED_CUSTOMER_IDS = new Set(['669', '705']);

const useOrderFlowV2Enabled = (): boolean => {
  const { currentAdmin } = useAuth();
  if (!currentAdmin) return false;

  // Pilot gate (kept here for easy reinstatement):
  // if (isCurrentCustomerAdmin(currentAdmin)) {
  //   return ORDER_FLOW_V2_ALLOWED_CUSTOMER_IDS.has(currentAdmin.customer.id);
  // }

  return true;
};

export default useOrderFlowV2Enabled;
